<a *ngIf="link||externalLink; else regularAvatar;" style="padding: 0px;" mat-button class="no-underline force-width no-align-item"
    [href]="link" (click)="goToLink($event)">
    <ng-container *ngTemplateOutlet="avatar"></ng-container>
</a>
<ng-template #regularAvatar>
    <ng-container *ngTemplateOutlet="avatar"></ng-container>
</ng-template>



<ng-template #avatar>
    <div class="avatar" [matTooltip]="tooltip"
        [matTooltipPosition]="tooltipPosition" matTooltipClass="syntooltip">

        <!-- Picture -->
        <div *ngIf="usePicture" class="avatar__ico" [ngStyle]="{backgroundImage: 'url('+avatarIco+')'}">
        </div>

        <div *ngIf="useSynIco || useMatIco || useInitials" [ngStyle]="{
            backgroundColor: muted ? 'transparent' : backgroundColor,
            fill: iconColor,
            color: iconColor
        }"
        class="avatar__ico">
            <!-- SynApps icon -->
            <mat-icon *ngIf="useSynIco" [ngStyle]="iconStyle" [class.synapps-icons__no-text]="!text" [class.syn-text--muted]="muted" fontSet="synapps">{{matIco}}</mat-icon>
            <!-- Material icon -->
            <mat-icon *ngIf="useMatIco" [ngStyle]="iconStyle" [class.syn-text--muted]="muted" [svgIcon]="matIco"></mat-icon>
            <!-- Initials -->
            <ng-container *ngIf="useInitials">{{ initials }}</ng-container>
        </div>

        <!-- Text -->
        <div *ngIf="text" class="avatar__text" [ngStyle]="{color: textColor}">
            <span 
            style="line-height: unset;" [ngStyle]="{width: maxWidth ? 'unset' : '195px', 'max-width': maxWidth ?? 'unset', 'white-space': wrap ? 'wrap' : 'nowrap'}">{{ text }}</span>

            <!-- Caption -->
            <div class="avatar__caption" [ngStyle]="{color: textColor}" *ngIf="caption">
                {{ caption }}
            </div>
        </div>

    </div>
</ng-template>
